import { navigateService } from '../shared/services/navigate/navigate.service';

// registration.update() returns a promise that REJECTS when the SW registration
// was uninstalled between the update being scheduled and run (a redeploy replaced
// it, the browser evicted it, or the user cleared site data), e.g.
// "TypeError: Failed to update the ServiceWorker ... because the registration has
// been uninstalled since the update was scheduled." An update check failing is
// benign — the app is unaffected and the next navigation retries — so we swallow
// it here instead of letting it escape as an unhandled rejection / Sentry noise
// (WA-3610).
const checkForUpdate = (registration: ServiceWorkerRegistration): void => {
  registration.update().catch(() => undefined);
};

export function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        // Force update check
        checkForUpdate(registration);
        // Check for updates on navigation
        navigateService.sub.state().subscribe(() => {
          checkForUpdate(registration);
        });

        // Handle immediate activation of new service worker
        registration.onupdatefound = () => {
          const newSW = registration.installing;
          if (newSW) {
            newSW.onstatechange = () => {
              if (newSW.state === 'installed' && navigator.serviceWorker.controller) {
                newSW.postMessage({ type: 'SKIP_WAITING' });
              }
            };
          }
        };
      })
      .catch((error) => {
        console.error('ServiceWorker registration failed:', error);
      });
  }
}
